export enum MedicineDeliveryRoutes {
    Root = "/solicitudes/delivery-medicamentos",
    Tracking = "/solicitudes/delivery-medicamentos/seguimiento",
    Register = "/solicitudes/delivery-medicamentos/registro",
    BasicData = "/solicitudes/delivery-medicamentos/registro/datos-basicos",
    LocationData = "/solicitudes/delivery-medicamentos/registro/datos-envio",
    DocumentsUpload = "/solicitudes/delivery-medicamentos/registro/documentos",
    Success = "/solicitudes/delivery-medicamentos/registro/exito",
}
